const version = '1.0.4';
export default version;